module.exports = __webpack_public_path__ + "img/4.e0fb7eea.jpg";